/**
 * Dashboard route — /app/dashboard
 *
 * Phase 9.5 (port): Renders the full Claude Design dashboard.
 */

import { createFileRoute } from '@tanstack/react-router';
import { Dashboard } from '../../components/dashboard/dashboard';

export const Route = createFileRoute('/app/dashboard')({
  component: Dashboard,
});
